import React from "react";
import "./style.css";

const Container = ({ children }: any) => (<div className={"container"}>
    {children}
</div>);

export default Container;
